import { components as fluentComponents } from "@glide/fluent-components/dist/js/fluent-components";
import { registerComponentHandler } from "../handlers";
import { DateFieldComponentHandler } from "./date-fields";
import { DateTimeFieldComponentHandler } from "./date-time-field";
import { EmailFieldComponentHandler } from "./email-field";
import { FilePickerComponentHandler } from "./file-picker";
import { getInflatorForComponent } from "./fluent-component-inflators";
import { makeFluentComponentHandler } from "./fluent-components-handlers";
import { ImagePickerComponentHandler } from "./image-picker";
import { InlineListComponentHandler } from "./inline-list";
import { NumberFieldComponentHandler } from "./number-field";
import { PhoneFieldComponentHandler } from "./phone-field";
import { SwitchComponentHandler } from "./switch";
import { TextFieldComponentHandler } from "./text-field";

let didInit = false;

export function registerComponentHandlers(): void {
    if (didInit) return;
    didInit = true;

    registerComponentHandler(new InlineListComponentHandler());
    registerComponentHandler(new TextFieldComponentHandler());
    registerComponentHandler(new DateTimeFieldComponentHandler());
    registerComponentHandler(new NumberFieldComponentHandler());
    registerComponentHandler(new PhoneFieldComponentHandler());
    registerComponentHandler(new EmailFieldComponentHandler());
    registerComponentHandler(new SwitchComponentHandler());
    registerComponentHandler(new ImagePickerComponentHandler());
    registerComponentHandler(new FilePickerComponentHandler());
    registerComponentHandler(new DateFieldComponentHandler());

    Object.values(fluentComponents).forEach(component => {
        registerComponentHandler(makeFluentComponentHandler(component, getInflatorForComponent(component.spec.kind)));
    });
}
